/* eslint class-methods-use-this: 0 no-param-reassign: 0 */

import { JsonPropertiesMapper } from 'jsona';

export default class MyJsonPropertiesMapper extends JsonPropertiesMapper {
  setAttributes(model, attributes) {
    this.snakeCaseToCamelCase(model, attributes);
  }

  setRelationships(model, relationships) {
    this.snakeCaseToCamelCase(model, relationships);
  }

  snakeCaseToCamelCase(model, values) {
    Object.keys(values).forEach((propName) => {
      const camelName = propName.replace(/_([a-z])/g, g => g[1].toUpperCase());
      model[camelName] = values[propName];
    });
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/data_formatter/snake_json_properties_mapper.js